export const Tablet = '@media (min-width: 768px)';
export const TabletPro = '@media (min-width: 1000px)';
export const Desktop = '@media (min-width: 1200px)';
